const SUPABASE_URL = (import.meta.env.VITE_PUBLIC_SUPABASE_URL as string) || '';

// Hosts que el sitio puede cargar directamente sin pasar por el relay.
const DIRECT_HOSTS = ['readdy.ai', 'storage.readdy-site.link', 'storage.helloreaddy.io', 'supabase.co'];

function isDirectHost(hostname: string): boolean {
  const host = hostname.toLowerCase();
  return DIRECT_HOSTS.some((h) => host === h || host.endsWith(`.${h}`));
}

/**
 * Convierte una URL de imagen en una URL cargable por el navegador.
 * Las imágenes externas se sirven a través del relay del backend, porque la
 * política de seguridad del sitio solo permite imágenes del propio dominio/CDN.
 */
export function resolveImageUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  const trimmed = url.trim();
  if (!trimmed) return null;

  if (
    trimmed.startsWith('data:') ||
    trimmed.startsWith('blob:') ||
    trimmed.startsWith('/')
  ) {
    return trimmed;
  }

  try {
    const parsed = new URL(trimmed);
    if (isDirectHost(parsed.hostname)) return trimmed;
    if (!SUPABASE_URL) return trimmed;
    return `${SUPABASE_URL}/functions/v1/image-proxy?url=${encodeURIComponent(trimmed)}`;
  } catch {
    return trimmed;
  }
}